import { registryApi } from '../clients/AxiosClients'

/**
 * Retorna as configurações do aplicativo
 */
export const buscarConfiguracoesDoAplicativo = async () => {
	return registryApi.get('v1/ConfiguracaoAplicativo')
}

/**
 * Atualiza as configuracoes do aplicativo
 */
export const atualizarConfiguracoesDoAplicativo = async (configuracoesAplicativo) => {
	return registryApi.put('v1/ConfiguracaoAplicativo', configuracoesAplicativo)
}
